export const reversePercent = (value?: number) => {
  return 100 - (value || 0);
};
